export const buttonColorMap = {
  1: '#bb252c',
  2: '#d66c2c',
  3: '#e8b932',
  4: '#72b452',
  5: '#37a659',
};

export const labels = {
  1: 'Pathetic',
  2: 'Bad',
  3: 'Average',
  4: 'Good',
  5: 'Excellent',
};

export const constants = {
  watchMedia: '(min-width: 600px)',
  modalSubmitFeedback: 'modalSubmitFeedback',
  modalChangeRating: 'modalChangeRating',
  submitFeedback: 'submitFeedback',
  accordionOnClick: 'accordionOnClick',
  expanded: 'expanded',
  collapsed: 'collapsed',
  ratingOne: 1,
  ratingTwo: 2,
  ratingYes: 'Yes',
  star: 'star',
  stars: 'stars',
};

export function defaultTheme(val, ratingValue) {
  const toggleTheme = {
    fontSize: '0.9rem',
    letterSpacing: '0.1rem',
    minWidth: '50px',
    color: '#919091',
    borderColor: '#ececec',
    borderRadius: '8px',
    maxHeight: '40px',
    fontFamily: 'Montserrat',
    backgroundColor: 'white',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: 'white',
      borderColor: '#ececec',
      color: 'white',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'white',
      borderColor: '#ececec',
      color: 'white',
    },
    '&.Mui-selected': {
      backgroundColor: 'white',
      borderColor: '#ececec',
      color: 'white',
    },
    '& > .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
      borderColor: '#ececec',
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
    },
    '&  .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
      borderTopLeftRadius: '8px',
      border: '1px solid #ececec',
      borderBottomLeftRadius: '8px',
    },
    '& > *:not(:last-child)': {
      marginRight: 1,
    },
  };
  toggleTheme['&:hover'].backgroundColor = buttonColorMap[val];
  toggleTheme['&:hover'].borderColor = buttonColorMap[val];
  toggleTheme['&.Mui-selected'].backgroundColor = buttonColorMap[val];
  toggleTheme['&.Mui-selected'].borderColor = buttonColorMap[val];
  toggleTheme['&.Mui-selected:hover'].backgroundColor = buttonColorMap[val];
  toggleTheme[
    '&  .MuiToggleButtonGroup-grouped:not(:first-of-type)'
  ].border = `1px solid ${val !== undefined ? buttonColorMap[val] : '#ececec'
  }`;
  if (val === ratingValue) {
    toggleTheme.backgroundColor = buttonColorMap[ratingValue];
    toggleTheme.color = 'white';
    toggleTheme.borderColor = buttonColorMap[val];
  }
  return toggleTheme;
}

export function dropdownTheme(value, isActive = false) {
  const toggleTheme = {
    fontSize: '12px',
    border: 'none',
    color: '#3c3c3c',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    height: '16px',
    lineHeight: '16px',
  };
  if (isActive && value != null) {
    toggleTheme.color = buttonColorMap[value] || toggleTheme.color;
    toggleTheme.fontWeight = 600;
  }
  return toggleTheme;
}

export function gridTheme(val) {
  const gridtheme = {
    paddingRight: '120px',
    marginLeft: '-12px',
    marginTop: '16px',
    textAlign: 'center',
  };
  const gridthemeResponsive = {
    paddingRight: '0px',
    marginLeft: '-8px',
    marginTop: '16px',
    textAlign: 'center',
  };
  return val ? gridthemeResponsive : gridtheme;
}

export function dialogTextTheme(isMobile) {
  const dialogStyle = {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: '1.1rem',
    letterSpacing: '-0.2px',
    padding: '8px 8px',
  };
  dialogStyle.fontSize = isMobile ? '1.1rem' : '1rem';
  return dialogStyle;
}

export function dialogContentTheme() {
  const dialogStyle = {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: '0.8rem',
    letterSpacing: '-0.2px',
    fontWeight: 500,
  };
  return dialogStyle;
}

export const globalStylesObject = {
  dialogPaperProps: {
    borderRadius: '12px',
    maxWidth: '600px',
  },
  internalButtonFirst: {
    marginTop: '12px',
    marginRight: '12px',
    color: '#909090',
    fontWeight: 600,
    fontSize: '14px',
    textTransform: 'none',
    textAlign: 'left',
    borderRadius: '8px',
    border: '1px solid #ebebeb',
    padding: 1.2,
    ':hover': {
      color: '#61cd4b',
      backgroundColor: '#edffec',
      border: '1px solid #61cd4b',
    },
  },
  internalButtonFirstSelected: {
    marginTop: '12px',
    marginRight: '12px',
    color: '#61cd4b',
    fontWeight: 600,
    fontSize: '14px',
    backgroundColor: '#edffec',
    textTransform: 'none',
    textAlign: 'left',
    borderRadius: '8px',
    border: '1px solid #61cd4b',
    padding: 1.2,
    ':hover': {
      color: '#61cd4b',
      backgroundColor: '#edffec',
      border: '1px solid #61cd4b',
    },
  },
  ButtonSelectedYes: {
    color: '#61cd4b',
    fontWeight: 600,
    fontSize: '14px',
    textTransform: 'none',
    textAlign: 'left',
    borderRadius: '8px',
    backgroundColor: '#edffec',
    border: '1px solid #61cd4b',
    paddingTop: 1.2,
    paddingBottom: 1.2,
    paddingLeft: 2,
    paddingRight: 2,
    justifyContent: 'flex-start',
    ':hover': {
      color: '#61cd4b',
      backgroundColor: '#edffec',
      border: '1px solid #61cd4b',
    },
    svg: {
      height: 20,
      width: 20,
    },
  },
  ButtonSelectedNo: {
    color: '#d52e2d',
    fontWeight: 600,
    fontSize: '14px',
    textTransform: 'none',
    textAlign: 'left',
    borderRadius: '8px',
    backgroundColor: '#fff6f6',
    border: '1px solid #d52e2d',
    paddingTop: 1.2,
    paddingBottom: 1.2,
    paddingLeft: 2,
    paddingRight: 2,
    justifyContent: 'flex-start',
    ':hover': {
      color: '#d52e2d',
      backgroundColor: '#fff6f6',
      border: '1px solid #d52e2d',
    },
    svg: {
      height: 20,
      width: 20,
    },
  },
  ButtonEmpty: {
    color: '#909090',
    fontWeight: 600,
    fontSize: '14px',
    textTransform: 'none',
    textAlign: 'left',
    borderRadius: '8px',
    border: '1px solid #ebebeb',
    paddingTop: 1.2,
    paddingBottom: 1.2,
    paddingLeft: 2,
    paddingRight: 2,
    justifyContent: 'flex-start',
    ':hover': {
      color: '#61cd4b',
      backgroundColor: '#edffec',
      border: '1px solid #61cd4b',
      '.MuiTypography-root': {
        color: '#61cd4b',
        fontWeight: 600,
        fontSize: '14px',
      },
    },
    svg: {
      height: 20,
      width: 20,
    },
  },
  ButtonEmptyNo: {
    color: '#909090',
    fontWeight: 600,
    fontSize: '14px',
    textTransform: 'none',
    textAlign: 'left',
    borderRadius: '8px',
    border: '1px solid #ebebeb',
    paddingTop: 1.2,
    paddingBottom: 1.2,
    paddingLeft: 2,
    paddingRight: 2,
    justifyContent: 'flex-start',
    ':hover': {
      color: '#d52e2d',
      backgroundColor: '#fff6f6',
      border: '1px solid #d52e2d',
      '.MuiTypography-root': {
        color: '#d52e2d',
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fontSize: '14px',
      },
    },
    svg: {
      height: 20,
      width: 20,
    },
  },
  Text: {
    color: '#909090',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '14px',
  },
  TextYes: {
    color: '#61cd4b',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '14px',
    ':hover': {
      color: '#61cd4b',
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontSize: '14px',
    },
  },
  TextNo: {
    color: '#d52e2d',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '14px',
    ':hover': {
      color: '#d52e2d',
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontSize: '14px',
    },
  },
  internalButton: {
    borderRadius: '8px',
    marginTop: '12px',
    marginRight: '12px',
    textAlign: 'left',
    color: '#909090',
    fontFamily: 'Montserrat',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    border: '1px solid #ebebeb',
    padding: 1.2,
    ':hover': {
      color: '#F1C40F',
      backgroundColor: '#FEF9E7',
      border: '1px solid #F1C40F',
    },
  },
  internalButtonSelected: {
    borderRadius: '8px',
    marginTop: '12px',
    marginRight: '12px',
    textAlign: 'left',
    color: '#F1C40F',
    backgroundColor: '#FEF9E7',
    fontFamily: 'Montserrat',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    border: '1px solid #F1C40F',
    padding: 1.2,
    ':hover': {
      color: '#F1C40F',
      backgroundColor: '#FEF9E7',
      border: '1px solid #F1C40F',
    },
  },
  internalButtonLast: {
    borderRadius: '8px',
    marginTop: '12px',
    marginRight: '12px',
    textAlign: 'left',
    color: '#909090',
    fontFamily: 'Montserrat',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    border: '1px solid #ebebeb',
    padding: 1.2,
    ':hover': {
      color: '#d52e2d',
      backgroundColor: '#fff6f6',
      border: '1px solid #d52e2d',
    },
  },
  internalButtonLastSelected: {
    borderRadius: '8px',
    marginTop: '12px',
    marginRight: '12px',
    textAlign: 'left',
    color: '#d52e2d',
    fontFamily: 'Montserrat',
    textTransform: 'none',
    fontWeight: 600,
    backgroundColor: '#fff6f6',
    fontSize: '14px',
    border: '1px solid #d52e2d',
    padding: 1.2,
    ':hover': {
      color: '#d52e2d',
      backgroundColor: '#fff6f6',
      border: '1px solid #d52e2d',
    },
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  yesNoButtonBox: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  buttonIcon: {},
  dialogPaperPropsResponsive: {
    borderRadius: '12px',
    maxWidth: 'calc(100% - 24px)',
  },
  shareFeedBackButton: {
    minWidth: '100%',
    backgroundColor: '#ff970a',
    color: 'white',
    marginTop: '24px',
    boxShadow: '0 0 10px #ff970a',
    borderRadius: '12px',
    minHeight: '50px',
    fontWeight: 600,
    fontFamily: 'Montserrat',
    textTransform: 'none',
    fontSize: '15px',
    '&:hover': {
      backgroundColor: '#ff970a',
      color: 'white',
    },
  },
  changeRatingButton: {
    minWidth: '100%',
    color: '#818181',
    marginTop: '16px',
    marginBottom: '12px',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    textTransform: 'none',
    lineHeight: '18px',
  },
  containerSx: {
    px: '12px',
    backgroundColor: '#f0fdf0',
    paddingBottom: 0,
    paddingTop: 2,
  },
  cardRoot: {
    borderRadius: 3.5,
  },
  cardRootTwo: {
    borderRadius: 3.5,
    marginTop: '18px',
  },
  cardContent: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  cardContentTwo: {
    padding: '17px',
  },
  cardTypography: {
    fontSize: 14,
    fontFamily: 'Manrope Variable',
    fontWeight: 700,
    color: '#8a8a8a',
    margin: '0px',
  },
  accordionContainer: {
    backgroundColor: '#f0fdf0',
    paddingBottom: 0,
  },
  closeButton: {
    marginTop: '-43px',
    float: 'right',
    color: '#969697',
    fontSize: '24px',
    paddingTop: '24px',
    paddingRight: '12px',
  },
  textContainer: {
    paddingTop: '48px',
  },
};
